import { TextareaAutosize } from "@mui/material";
import { getIn } from "formik";

export function InputTextArea({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, handleBlur, handleChange }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  type = "text",
  size = "small",
  variant = "outlined",
  minRows = 3,
  maxRows = 5,
  ...props
}) {
  return (
    <>
      <TextareaAutosize
        minRows={minRows}
        maxRows={maxRows}
        size={size}
        type={type}
        name={field.name}
        label={label}
        variant={variant}
        onBlur={handleBlur}
        onChange={handleChange}
        helperText={getIn(touched, field.name) && getIn(errors, field.name)}
        error={Boolean(getIn(touched, field.name) && getIn(errors, field.name))}
        {...field}
        {...props}
      />
    </>
  );
}
